jQuery(function ($) {
    const $nav = $('#primary-navigation');
    if (!$nav.length) return;

    const OPEN_CLASS = 'show';
    const BODY_OPEN_CLASS = 'menu-open';
    const ITEM = '.menu-item-has-children';
    const SUBMENU = '> .sub-menu';
    const HAS_MORE_CLASS = 'has-more';
    // Keep in sync with the `xl` breakpoint in assets/scss/_utils.scss
    const desktopMq = window.matchMedia('(min-width: 1200px)');
    const $body = $(document.body);

    // Ensure nav has an accessible label (if one isn't already provided)
    if (!$nav.attr('aria-label') && !$nav.attr('aria-labelledby')) {
        $nav.attr('aria-label', 'Primary navigation');
    }

    // Build submenu toggles
    $nav.find(ITEM).each(function (i) {
        const $item = $(this);
        const $submenu = $item.find(SUBMENU).first();
        const $link = $item.children('a').first();

        if (!$submenu.length || !$link.length) return;

        // Avoid double-inserting toggles if script runs more than once
        if ($item.children('.sub-toggle').length) return;

        // Ensure submenu has an ID for aria-controls
        let submenuId = $submenu.attr('id');
        if (!submenuId) {
            const base = ($item.attr('id') || `menu-item-${i}`).replace(/[^a-zA-Z0-9\-_]/g, '');
            submenuId = `submenu-${base}`;
            $submenu.attr('id', submenuId);
        }

        // Initialize closed state
        $submenu
            .removeClass(OPEN_CLASS)
            .attr('aria-hidden', 'true');

        // Create toggle button (keeps the <a> as a real link)
        const labelText = $.trim($link.text()) || 'submenu';
        const $btn = $('<button />', {
            type: 'button',
            class: 'sub-toggle',
            'aria-expanded': 'false',
            'aria-controls': submenuId,
            'aria-label': `Toggle ${labelText}`
        });

        $link.after($btn);

        $submenu[0].addEventListener('scroll', () => updateScrollHint($submenu), { passive: true });

        // Inject a mobile-only back button as the first item in the submenu
        if (!$submenu.children('.sub-menu-back').length) {
            const $back = $('<li />', { class: 'sub-menu-back' }).append(
                $('<button />', {
                    type: 'button',
                    class: 'sub-back-btn',
                    'aria-label': `Back to ${labelText}`,
                    text: labelText,
                })
            );
            $submenu.prepend($back);

            $back.find('.sub-back-btn').on('click', function () {
                setState($btn, $submenu, false);
                syncBodyClass();
                $btn.trigger('focus');
            });
        }

        // Intercept clicks on the parent link — prevent navigation and toggle
        // the submenu instead. If the item has a real destination that should
        // remain accessible, it can still be reached via keyboard (Enter on the
        // <a> itself) or by re-evaluating to Option B later.
        $link.on('click', function (e) {
            e.preventDefault();
            $btn.trigger('click');
        });

        // Click toggles submenu (baseline accessible behavior)
        $btn.on('click', function (e) {
            e.preventDefault();

            const isOpen = $btn.attr('aria-expanded') === 'true';
            closeSiblings($item);
            setState($btn, $submenu, !isOpen);
            syncBodyClass();
        });

        // Esc closes the current submenu and returns focus to the toggle
        $btn.on('keydown', function (e) {
            if (e.key === 'Escape') {
                setState($btn, $submenu, false);
                syncBodyClass();
                $btn.trigger('focus');
            }
        });

    });

    // Click outside closes all open submenus
    $(document).on('click', function (e) {
        if (!$(e.target).closest($nav).length) {
            closeAll();
            syncBodyClass();
        }
    });

    // Esc closes any open submenu while focus is inside the nav
    $nav.on('keydown', function (e) {
        if (e.key === 'Escape') {
            closeAll();
            syncBodyClass();
        }
    });

    function setState($btn, $submenu, open) {
        $btn
            .toggleClass(OPEN_CLASS, open)
            .attr('aria-expanded', open ? 'true' : 'false');

        $submenu
            .toggleClass(OPEN_CLASS, open)
            .attr('aria-hidden', open ? 'false' : 'true');

        if (!open) {
            $submenu.removeClass(HAS_MORE_CLASS);
            return;
        }

        updateScrollHint($submenu);
    }

    // Flags an open desktop submenu that has more items below its visible area
    function updateScrollHint($submenu) {
        const el = $submenu[0];
        if (!el) return;

        if (!desktopMq.matches || !$submenu.hasClass(OPEN_CLASS)) {
            $submenu.removeClass(HAS_MORE_CLASS);
            return;
        }

        const remaining = el.scrollHeight - el.scrollTop - el.clientHeight;
        $submenu.toggleClass(HAS_MORE_CLASS, remaining > 1);
    }

    let hintFrame = null;
    function refreshOpenScrollHints() {
        if (hintFrame) return;

        hintFrame = window.requestAnimationFrame(() => {
            hintFrame = null;
            $nav.find(`.sub-menu.${OPEN_CLASS}`).each(function () {
                updateScrollHint($(this));
            });
        });
    }

    window.addEventListener('resize', refreshOpenScrollHints, { passive: true });
    desktopMq.addEventListener('change', refreshOpenScrollHints);

    function closeSiblings($current) {
        $current.siblings(ITEM).each(function () {
            const $sibling = $(this);
            const $btn = $sibling.children('a').siblings('.sub-toggle').first();
            const $submenu = $sibling.find(SUBMENU).first();

            if ($btn.length && $submenu.length) {
                setState($btn, $submenu, false);
            }
        });
    }

    function closeAll() {
        $nav.find('.sub-toggle[aria-expanded="true"]').each(function () {
            const $btn = $(this);
            const submenuId = $btn.attr('aria-controls');
            const $submenu = submenuId ? $('#' + submenuId) : $btn.closest(ITEM).find(SUBMENU).first();
            if ($submenu.length) {
                setState($btn, $submenu, false);
            }
        });
    }

    // Adds/removes .menu-open on <body> when any submenu is expanded
    function syncBodyClass() {
        const anyOpen = $nav.find('.sub-toggle[aria-expanded="true"]').length > 0;
        $body.toggleClass(BODY_OPEN_CLASS, anyOpen);
    }

    // Initial sync (in case server-side markup ships with an open state)
    syncBodyClass();
});
